module.exports = __webpack_public_path__ + "static/media/act0.8bd6099b.mpeg";